export const regularTextStyles = {
    // color: 'black',
    fontSize: '1rem', //16px
    fontFamily: 'Lato',
    fontWeight: '400',
    wordWrap: 'break-word',
};
export const disclaimerTextStyles = {
  // color: 'black',
  fontSize: '15px',
  fontFamily: 'Lato',
  fontWeight: '400',
  wordWrap: 'break-word',
};
export const disclaimerBoldTextStyles = {
  // color: 'black',
  fontSize: '15px',
  fontFamily: 'Lato',
  fontWeight: '700',
  wordWrap: 'break-word',
};
export const boldTextStyles = {
    // color: 'black',
    fontSize: '1rem', //16px
    fontFamily: 'Lato',
    fontWeight: '700',
    wordWrap: 'break-word',
};

export const mediumTextStyles = {
    // color: 'black',
    fontSize: '1.25rem', //20px
    fontFamily: 'Lato',
    fontWeight: '400',
    wordWrap: 'break-word',
};

export const subHeadingStyles = {
    // color: 'black',
    fontSize: '1.75rem', //28px
    fontFamily: 'Lato',
    fontWeight: '900',
    wordWrap: 'break-word',
};

export const headingStyles = {
    // color: 'black',
    fontSize: '4.375rem', //70px
    fontFamily: 'Lato',
    fontWeight: '800',
    wordWrap: 'break-word',
};

export const placeholderMediumTextStyles = {
    color: '#D1D5DB',
    fontSize: '0.875rem', //14px
    fontFamily: 'Lato',
    fontWeight: '500',
    wordWrap: 'break-word',
};
export const placeholderRegularTextStyles = {
    fontSize: '0.875rem', //14px
    fontFamily: 'Lato',
    fontWeight: '400',
    wordWrap: 'break-word',
};
export const regularBlueTextStyles = {
    ...regularTextStyles,
    color: '#1851A3',
};
export const subHeadingWhiteTextStyles = {
    color: 'white',
    fontSize: '1.75rem',
    fontFamily: 'Lato',
    fontWeight: '900',
    wordWrap: 'break-word',
};
export const regularErrorStyle = {
    color: 'red',
    fontSize: 12,
    marginTop: 5
};
export const errorInputBoxStyle = {
    boxShadow: '0px 1px 2px rgba(255, 0, 0, 0.3)',
    border: '1px #FF0000 solid',
};

export const buttonStyle = {
    wordWrap: "break-word",
    width: "100%",
    maxWidth: "150px",
    lineHeight: "30px",
    borderRadius: 50,
    top: "2px",
    position: "relative",
    overflow: "hidden",
    justifyContent: "center",
    alignItems: "center",
    display: "inline-flex",
    cursor: "pointer",
    border: "1px solid #D1D5DB",

}
